export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_page_perseus/stars_icon.abc0a2f.gif";